<mat-dialog-content class="p-4 dark-bg">
    <div class="dark-mode">
        <h3 class="text-white" style="font-size: 25px;" *ngIf="data.mode == 'new'">Add New Training</h3>
        <h3 class="text-white" style="font-size: 25px;" *ngIf="data.mode == 'edit'">Edit Training</h3>
        <form [formGroup]="form">
            <div class="row mt-5">
                <div class="col-12">
                    <mat-form-field class="full-width w-100" appearance="outline">
                        <mat-label>Title</mat-label>
                        <input type="text" matInput formControlName="title">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">

                <div class="col-6 d-flex">
                    <mat-form-field class="full-width w-100" appearance="outline" >
                        <mat-label>Provider</mat-label>
                        <mat-select formControlName="provider" (selectionChange)="onProviderChanged($event)">
                            <mat-option *ngFor="let provider of providers" [value]="provider.id">
                                {{ provider.providerName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="full-width w-100" appearance="outline" >
                        <mat-label>Certification</mat-label>
                        <mat-select formControlName="certificationId">
                            <mat-option *ngFor="let cert of certs" [value]="cert.id">
                                {{ cert.certificationTitle }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">

                <div class="col-6">
                    <mat-form-field class="full-width w-100" appearance="outline" >
                        <mat-label>Training Type</mat-label>
                        <mat-select formControlName="ceType">
                            <mat-option *ngFor="let param of ceTypeParams.parameterMembers" [value]="param.parameterValue">
                                {{ param.parameterLabel }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="full-width w-100" appearance="outline" >
                        <mat-label>Attendance Type</mat-label>
                        <mat-select formControlName="attendanceType">
                            <mat-option *ngFor="let param of attendanceTypeParams.parameterMembers" [value]="param.parameterValue">
                                {{ param.parameterLabel }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">

                <div class="col-12 col-md-12 col-sm-12 col-lg-6">
                    <mat-form-field class="full-width w-100" appearance="outline">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="startDate">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-12 col-sm-12 col-lg-6">
                    <mat-form-field class="full-width w-100" appearance="outline">
                        <mat-label>End Date</mat-label>
                        <input matInput [matDatepicker]="picker2" formControlName="endDate">
                        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-sm-12 col-lg-4">
                    <mat-form-field class="full-width w-100" appearance="outline">
                        <mat-label>City</mat-label>
                        <input type="text" matInput formControlName="city">
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-12 col-sm-12 col-lg-4">
                    <mat-form-field class="full-width w-100" appearance="outline">
                        <mat-label>State</mat-label>
                        <input type="text" matInput formControlName="state" >
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-12 col-sm-12 col-lg-4">
                    <mat-form-field class="full-width w-100" appearance="outline">
                        <mat-label>Zip Code</mat-label>
                        <input type="text" matInput formControlName="zipcode" >
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-sm-12 col-lg-4">
                    <mat-form-field class="full-width w-100" appearance="outline">
                        <mat-label>Cost</mat-label>
                        <input class="text-end" type="text" matInput formControlName="cost" mask="separator" thousandSeparator="," decimalMarker=".">
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-12 col-sm-12 col-lg-4 text-color-black-normal-50" style="margin-top: 20px" clas>
                    <mat-slide-toggle formControlName="active" (change)="onActiveChange($event)">
                        <span class="text-color-black-normal-50">{{ published }}</span>
                    </mat-slide-toggle>
                </div>
            </div>
        </form>
    </div>

</mat-dialog-content>
<mat-dialog-actions class=" dark-mode p-4 justify-content-end dark-bg">
    <button mat-raised-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="warn" (click)="resetForm()">Reset</button>
    <button mat-raised-button class="bg-accent-orange" (click)="save()">Save</button>
</mat-dialog-actions>
